import {Button, Card} from "antd";
import {FormattedMessage} from "react-intl";
import {LeftOutlined} from "@ant-design/icons";
import React, {useContext} from "react";
import {ExitPromptContext} from "../../context/ExitPromptContext";
import {useNavigate} from "react-router-dom";

interface DetailWrapperProps {
    children?: any;
    navigateBack?: string;
    removeVerticalScroll?: boolean;
}

const DetailWrapper = (props: DetailWrapperProps) => {
    const {isFormDirty, setExitModalOpen, setExitModalAction} = useContext(ExitPromptContext);

    const navigate = useNavigate();

    const handleClick = (e: any) => {
        e.preventDefault();

        if (props.navigateBack) {
            if (isFormDirty) {
                setExitModalOpen(true);
                setExitModalAction(props.navigateBack);
            } else {
                navigate(props.navigateBack);
            }
        }
    };

    return (
        <Card
            bordered={false}
            style={props.removeVerticalScroll ? {overflowY: 'hidden'} : {}}
            className={"dentobook-content disable-side-scroll"}
        >
            {
                props.navigateBack ?
                    <Button className="back-link" type="link" onClick={handleClick}>
                        <span className="text-black"><LeftOutlined/></span>
                        <span className="text-blue font-weight-500 ml-05"><FormattedMessage id="back"/></span>
                    </Button>
                    : null
            }

            <div>{props.children}</div>
        </Card>
    );
}

export default DetailWrapper;